<template>
  <div>
    <div v-if="!userCreated">

      <div class="register-container">
        <div class="row">
          <div class="col-md-12">
            <div class="text-center m-b-md">
              <h3>Free Sign up</h3>
              <small>This sign up allows you to interact about this question with the question owner.</small>
              <br>
              <small>You can also benefit from a free trial of our Open Innovation service</small>
            </div>
            <div class="hpanel">
              <div class="panel-body">
                <form v-on:submit="register" action="#" method="post" id="registerForm">
                  <div class="row" style="margin-top: 25px">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="form-group col-lg-6" v-bind:class="{'has-error' : errorFirstName , 'has-success' : errorFirstName === false}">
                          <label for="firstName" class="required">{{ $t('signUp.form_firstName.label') }}</label>
                          <input type="" v-model="firstName" id="firstName" class="form-control" name="firstName" v-bind:placeholder="$t('signUp.form_firstName.place_holder')" required>
                          <span v-if="errorFirstName " class="help-block text-danger">{{ errorFirstName }}</span>
                        </div>
                        <div class="form-group col-lg-6" v-bind:class="{'has-error' : errorLastName , 'has-success' : errorLastName === false}">
                          <label for="LastName" class="required">{{ $t('signUp.form_lastName.label') }}</label>
                          <input type="" v-model="lastName" id="lastName" class="form-control" name="lastName" v-bind:placeholder="$t('signUp.form_lastName.place_holder')" required>
                          <span v-if="errorLastName" class="help-block text-danger">{{ errorLastName }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="form-group col-lg-6" v-bind:class="{'has-error' : errorEmail, 'has-success' : errorEmail === false}" >
                          <label for="email" class="required">{{ $t('signUp.form_email.label') }}</label>
                          <input type="email" v-model="email" id="email" class="form-control" name="email" v-bind:placeholder="$t('signUp.form_email.place_holder')" required>
                          <span v-if="errorEmail" class="help-block text-danger">{{ errorEmail }}</span>
                        </div>
                        <div class="form-group col-lg-6" v-bind:class="{'has-error' : errorEmailConfirm, 'has-success' : errorEmailConfirm === false}">
                          <label for="emailConfirm" class="required">{{ $t('signUp.form_emailConfirm.label') }}</label>
                          <input type="email" v-model="emailConfirm" id="emailConfirm" class="form-control" name="emailConfirm" v-bind:placeholder="$t('signUp.form_emailConfirm.place_holder')" required>
                          <span v-if="errorEmailConfirm === true" class="help-block text-danger">{{ $t('signUp.form_emailConfirm.required') }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="row">
                        <div class="form-group col-lg-6" v-bind:class="{'has-error' : errorPassword, 'has-success' : errorPassword === false}">
                          <label for="password" class="required">{{ $t('signUp.form_password.label') }}</label>
                          <input type="password" v-model="password" id="password" class="form-control" name="password" v-bind:placeholder="$t('signUp.form_password.place_holder')" required>
                          <span v-if="errorPassword" class="help-block text-danger">{{ errorPassword }}</span>
                        </div>
                        <div class="form-group col-lg-6" v-bind:class="{'has-error' : errorPasswordConfirm, 'has-success' : errorPasswordConfirm === false}">
                          <label for="passwordConfirm" class="required">{{ $t('signUp.form_passwordConfirm.label') }}</label>
                          <input type="password" v-model="passwordConfirm" id="passwordConfirm" class="form-control" name="passwordConfirm" v-bind:placeholder="$t('signUp.form_passwordConfirm.place_holder')" required>
                          <span v-if="errorPasswordConfirm" class="help-block text-danger">{{ $t('signUp.form_passwordConfirm.required') }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="row">
                        <div class="form-group col-lg-6">
                          <label for="companyName">{{ $t('signUp.form_company.label') }}</label>
                          <input type="" v-model="companyName" id="companyName" class="form-control" name="companyName" v-bind:placeholder="$t('signUp.form_company.place_holder')">
                        </div>
                        <div class="form-group col-lg-6">
                          <label for="website">{{ $t('signUp.form_website.label') }}</label>
                          <input type="" v-model="website" id="website" class="form-control" name="website" v-bind:placeholder="$t('signUp.form_website.place_holder')">
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12" style="margin-top: 10px">
                      <div class="checkbox checkbox-info" >
                        <input type="checkbox" style="position: absolute; opacity: 0;" name="termsOfUse" v-model="termsOfUse" required>
                        <label v-html="$t('signUp.form_checkbox_termsOfUse.label')"> </label>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="checkbox checkbox-info">
                        <input type="checkbox" style="position: absolute; opacity: 0;" name="news" v-model="news">
                        <label class=""> {{ $t('signUp.form_checkbox_news.label') }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="text-center" style="margin-top: 10px">
                    <vue-ladda type="submit" :loading="submitRegister.loading" class="btn btn-info" :data-style="submitRegister.dataStyle">Free Registration</vue-ladda>

                    <router-link :to="{name: 'Login'}" class="btn btn-default">{{ $t('signUp.form.cancel') }}</router-link>
                  </div>
                  <div style="text-align: right;margin-top: 10px">
                    <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{ $moment().year() }} Copyright Idexlab
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="emailNotChanged === false">
      <enable-account v-bind:email="email"/>
    </div>
  </div>

</template>

<script>

import EnableAccount from '../login/EnableAccount'
import VueLadda from 'vue-ladda'

export default {
  components: {
    EnableAccount,
    VueLadda
  },
  name: 'RegisterExpert',
  methods: {
    register: function (event) {
      this.emailNotChanged = typeof this.$route.params.email !== 'undefined' && this.$route.params.email === this.email

      let redirect = this.$auth.redirect()

      this.submitRegister.loading = true
      if (this.lastName === '' || this.firstName === '' || this.email === '' || this.emailConfirm === '' ||
          this.password === '' || this.passwordConfirm === '' || this.termsOfUse === false ||
          this.email !== this.emailConfirm || this.password !== this.passwordConfirm) {
        this.errorFirstName = !this.firstName
        this.errorLastName = !this.lastName
        this.errorEmail = !this.email
        this.errorEmailConfirm = !(this.errorEmail === false && this.email === this.emailConfirm)
        this.errorPassword = !this.password
        this.errorPasswordConfirm = !(this.errorPassword === false && this.password === this.passwordConfirm)
        this.errorTermsOfUse = !this.termsOfUse

        if (this.errorEmailConfirm === true) {
          this.emailConfirm = ''
        }
        if (this.errorPasswordConfirm === true) {
          this.passwordConfirm = ''
        }
        this.submitRegister.loading = false
      } else {
        this.errorLastName = false
        this.errorFirstName = false
        this.errorEmail = false
        this.errorEmailConfirm = false
        this.errorPassword = false
        this.errorPasswordConfirm = false
        this.errorTermsOfUse = false

        this.$auth.register({
          data: {
            email: this.email,
            lastName: this.lastName,
            firstName: this.firstName,
            password: this.password,
            company: this.companyName,
            website: this.website,
            newsletter: this.news,
            emailConfirmed: this.emailNotChanged,
            isSME: true,
            plan: 'expert'
          },
          autoLogin: this.emailNotChanged,
          redirect: this.emailNotChanged === true ? {name: (redirect ? redirect.from.name : 'ReceiveQuestions')} : null,
          success: (res) => {
            this.userCreated = true
            this.submitRegister.loading = false
            this.$salesMachine.clearUser()
            this.$salesMachine.signUp()
          },
          error: (res) => {
            if (res.response.status === 400) {
              let errors = res.response.data.errors
              switch (res.response.data.code) {
                case 1:
                  this.errorEmail = errors['email'][0]
                  break
                case 2:
                  this.errorLastName = errors['lastName'][0]
                  break
                case 3:
                  this.errorFirstName = errors['firstName'][0]
                  break
                case 4:
                  this.errorPassword = errors['password'][0]
                  break
              }
            }
            this.submitRegister.loading = false
          }
        })
      }
      event.preventDefault()
    }
  },
  data () {
    return {
      firstName: typeof this.$route.params.firstName !== 'undefined' ? this.$route.params.firstName : '',
      lastName: typeof this.$route.params.lastName !== 'undefined' ? this.$route.params.lastName : '',
      email: typeof this.$route.params.email !== 'undefined' ? this.$route.params.email : '',
      emailConfirm: typeof this.$route.params.email !== 'undefined' ? this.$route.params.email : '',
      password: '',
      passwordConfirm: '',
      companyName: '',
      website: '',
      termsOfUse: false,
      news: true,
      emailNotChanged: false,
      errorLastName: null,
      errorFirstName: null,
      errorEmail: null,
      errorEmailConfirm: null,
      errorPassword: null,
      errorPasswordConfirm: null,
      errorTermsOfUse: null,
      userCreated: false,
      submitRegister: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/register/RegisterExpert.vue